import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  Button,
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  Popover,
  Menu,
  MenuItem,
  TextField,
} from '@mui/material';
import moment from 'moment';

import FormPhoneField2 from 'components/ui/form/FormPhoneField2';
import useFormSubmit from 'hooks/useFormSubmit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

// SMS shablonidagi o'zgaruvchilar: ${contact.name}, ${name}, ${date}
const SMS_VAR_REGEX = /\$\{[^}]+\}/;
const UZ_MONTHS = [
  'yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
  'iyul', 'avgust', 'sentabr', 'oktabr', 'noyabr', 'dekabr',
];
// Topshiriq sanasi "15-may" ko'rinishida
const formatTaskDate = (d) => {
  if (!d) return '';
  const m = moment(d);
  return m.isValid() ? `${m.date()}-${UZ_MONTHS[m.month()]}` : '';
};

export default function ContactInputForm({
  index,
  formik,
  contact,
  handleAddPhone,
  contactInd,
  smsList,
  lead,
}) {
  const { submit, isSubmitting } = useFormSubmit();
  const [isEditing, setIsEditing] = useState(
    !formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone
  );
  const axiosPrivate = useAxiosPrivate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openNested, setOpenNested] = useState(false);
  const { id: leadId } = useParams();
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const anchorNestedEl = document.querySelector('.button-crm-sms-menu');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onEdit = () => {
    setAnchorEl(null);
    setIsEditing(true);
  };
  const onCopy = () => {
    navigator.clipboard.writeText(
      formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone || ''
    );
  };
  const onCalling = async () => {
    handleClose();
    try {
      await axiosPrivate.post(
        '/crm/crm-lead/call-moizvanki',
        JSON.stringify({
          phone:
            formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone || '',
        }),
        { headers: { 'Content-Type': 'application/json' } }
      );
    } catch (error) {}
  };

  const menuToggle = () => {
    setOpenNested((prev) => !prev);
  };

  // Modal: o'zgaruvchili shablon uchun avto-to'ldirilgan matn
  const [smsModal, setSmsModal] = useState(null); // {sms, text}

  const fillVars = (text) => {
    const contactName = formik.values?.contacts?.[contactInd]?.name || '';
    const taskDate = formatTaskDate(lead?.checktask?.date);
    return (text || '')
      .replaceAll('${contact.name}', contactName)
      .replaceAll('${name}', contactName)
      .replaceAll('${date}', taskDate);
  };

  const doSend = (smsId, text) => {
    const body = {
      phone: formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone,
      smsId,
      ...(text ? { text } : {}),
    };
    submit(
      { type: 'post', contentType: 'simple' },
      body,
      `/crm/crm-lead/send-sms/${leadId}`,
      body.phone,
      null,
      true,
      handleClose
    );
  };

  const sendMessage = (sms) => {
    // O'zgaruvchili shablon — modal ochamiz (avto-to'ldirilgan, tahrirlash mumkin)
    if (SMS_VAR_REGEX.test(sms?.text || '')) {
      setSmsModal({ sms, text: fillVars(sms?.text) });
      setOpenNested(false);
      return;
    }
    // O'zgaruvchisiz — hozirgidek to'g'ridan-to'g'ri yuboriladi
    doSend(sms?.id);
  };

  const sendFilledSms = () => {
    doSend(smsModal?.sms?.id, smsModal?.text);
    setSmsModal(null);
  };

  return (
    <div className='item-value max-w-[150px] contact-value phone-value'>
      {index == contact.phones.length - 1 ? (
        <ButtonBase
          className='add-phone-btn !text-[#818181]'
          onClick={() => handleAddPhone(contactInd)}
        >
          <i className='bi bi-plus-circle' />
        </ButtonBase>
      ) : (
        <div className='mr-6'></div>
      )}
      {isEditing && (
        <FormPhoneField2
          className='cursor-pointer'
          delay={0}
          duration={0}
          label=''
          fieldName={`contacts.${contactInd}.phones.${index}.phone`}
          formik={formik}
          variant='standard'
          autocomplete='off'
          sx={{
            '.MuiInputBase-input': { textAlign: 'right', paddingRight: '5px' },
          }}
          onBlur={() =>
            formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone &&
            leadId
              ? setIsEditing(false)
              : null
          }
        />
      )}
      {!isEditing && (
        <div
          className='text-sm text-right cursor-pointer border-b border-b-black pr-[5px] w-full py-1 border-t border-t-transparent'
          onClick={handleClick}
          tabIndex={1}
        >
          {formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone || ''}
        </div>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className='flex flex-col'>
          <Link
            className='add-phone-btn no-underline'
            to={`tel:${formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone}`}
          >
            <Button
              size='small'
              fullWidth
              startIcon={<i className='bi bi-telephone' />}
              className='!px-3 !rounded-none !text-gray-700 hover:!bg-gray-200'
              sx={{ justifyContent: 'start' }}
            >
              Qo'ng'iroq qilish
            </Button>
          </Link>

          <Button
            size='small'
            fullWidth
            startIcon={<i className='bi bi-telephone' />}
            className='!px-3 !rounded-none !font-semibold !text-gray-700 hover:!bg-gray-200'
            sx={{ justifyContent: 'start' }}
            onClick={onCalling}
          >
            Qo'ng'iroq qilish (Мои Звонки)
          </Button>

          <Button
            size='small'
            fullWidth
            startIcon={
              isSubmitting ? (
                <i className='bi bi-arrow-repeat animate-spin' />
              ) : (
                <i className='bi bi-envelope' />
              )
            }
            className='button-crm-sms-menu !px-3 !rounded-none !text-gray-700 hover:!bg-gray-200'
            sx={{ justifyContent: 'start' }}
            // onClick={sendMessage}
            onClick={menuToggle}
            endIcon={<i className='bi bi-chevron-right !text-[12px]' />}
          >
            SMS yuborish
          </Button>
          <Menu
            open={openNested}
            anchorEl={anchorNestedEl}
            disableScrollLock={true}
            onClose={menuToggle}
            className='-translate-x-2.5 -translate-y-2'
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            {smsList?.map((sms) => (
              <MenuItem key={sms?.id} onClick={() => sendMessage(sms)}>
                {sms?.name || ''}
              </MenuItem>
            ))}
          </Menu>
          <Link
            className='add-phone-btn no-underline'
            to={`https://t.me/${formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone}`}
          >
            <Button
              size='small'
              fullWidth
              startIcon={<i className='bi bi-send' />}
              className='!px-3 !rounded-none !text-gray-700 hover:!bg-gray-200'
              sx={{ justifyContent: 'start' }}
            >
              Telegramda ochish
            </Button>
          </Link>

          <Button
            size='small'
            fullWidth
            startIcon={<i className='bi bi-clipboard-check' />}
            className='!px-3 !rounded-none !text-gray-700 hover:!bg-gray-200'
            sx={{ justifyContent: 'start' }}
            onClick={onCopy}
          >
            Nusxa olish
          </Button>
          <Button
            size='small'
            fullWidth
            startIcon={<i className='bi bi-pencil' />}
            className='!px-3 !rounded-none !text-gray-700 hover:!bg-gray-200'
            sx={{ justifyContent: 'start' }}
            onClick={onEdit}
          >
            Tahrirlash
          </Button>
        </div>
      </Popover>

      {/* O'zgaruvchili SMS shablon — avto-to'ldirilgan matnni tasdiqlash */}
      <Dialog
        open={Boolean(smsModal)}
        onClose={() => setSmsModal(null)}
        maxWidth='sm'
        fullWidth
        PaperProps={{ className: '!base-border !shadow-none' }}
      >
        <DialogTitle className='!bg-gray-100 !mb-3'>
          <div className='flex items-center justify-between'>
            <span className='text-[15px]'>
              {smsModal?.sms?.name || 'SMS yuborish'}
            </span>
            <span className='text-[13px] text-gray-500'>
              {formik.values?.contacts?.[contactInd]?.phones?.[index]?.phone}
            </span>
          </div>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            minRows={4}
            value={smsModal?.text || ''}
            onChange={(e) =>
              setSmsModal((prev) => ({ ...prev, text: e.target.value }))
            }
          />
          <div className='flex justify-end gap-2 mt-3'>
            <Button
              variant='outlined'
              color='error'
              size='small'
              onClick={() => setSmsModal(null)}
            >
              Bekor qilish
            </Button>
            <Button
              variant='contained'
              color='success'
              size='small'
              disabled={isSubmitting || !smsModal?.text?.trim()}
              startIcon={
                isSubmitting ? (
                  <i className='bi bi-arrow-repeat animate-spin' />
                ) : (
                  <i className='bi bi-send' />
                )
              }
              onClick={sendFilledSms}
            >
              Yuborish
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
